import React from 'react'
import { cn } from '~/shadcn/lib/utils'
import { useFeeNotification } from './useFeeNotification'
import { NotificationText } from '../NotificationText'

function FeeNotification() {
  const { isNotificationReady, notificationText, downloadFeeNoticeDocument } =
    useFeeNotification()

  async function handleClick(
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) {
    e.preventDefault()
    void downloadFeeNoticeDocument()
  }

  if (!isNotificationReady) return null

  return (
    <NotificationText
      title={
        <>
          {notificationText}
          {` `}
          <a
            onClick={handleClick}
            href="#"
            target="_blank"
            rel="noopener noreferrer"
            className={cn(
              'text-[#121212] border-b border-[#121212] no-underline',
              'hover:text-[#121212] hover:no-underline cursor-pointer'
            )}>
            dokumente
          </a>
          .
        </>
      }
      body=""
    />
  )
}

export { FeeNotification }
